
import { defineComponent, onMounted, reactive, ref, h } from "vue";
import XAtable from "@/components/XATable.vue";
import { recycleQueryList, recycleXls } from "@/api/api";
import { message, Tag } from "ant-design-vue";

export default defineComponent({
  components: {
    XAtable,
  },
  setup() {
    const dateFormat = "YYYY-MM-DD";
    const loading = ref(false);
    const exportLoading = ref(false);
    const tableData = ref<any[]>([]);
    const pageNo = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const searchForm = reactive({
      userId: "",
      adsId: "",
      type: undefined as number | undefined,
      userType: undefined as number | undefined,
      timeRange: null as [string, string] | null,
    });

    const columns = [
      { title: "日期", key: "day", dataIndex: "day" },
      { title: "金额($)", key: "amount", dataIndex: "amount" },
      { title: "用户ID", key: "userId", dataIndex: "userId" },
      { title: "广告账户ID", key: "adsId", dataIndex: "adsId" },
      {
        title: "类型",
        key: "type",
        dataIndex: "type",
        customRender: ({ text }: { text: number }) => {
          if (text === 0) {
            return h(Tag, { color: "green" }, () => "自动");
          }
          if (text === 1) {
            return h(Tag, { color: "blue" }, () => "手动");
          }
          return "-";
        },
      },
      {
        title: "用户类型",
        key: "userType",
        dataIndex: "userType",
        customRender: ({ text }: { text: number }) => {
          if (text === 1) {
            return h(Tag, { color: "blue" }, () => "内部");
          }
          if (text === 0) {
            return h(Tag, { color: "green" }, () => "外部");
          }
          return "-";
        },
      },
      { title: "母BM", key: "bmBase", dataIndex: "bmBase" },
      { title: "时区", key: "gmt", dataIndex: "gmt" },
      { title: "指纹编号", key: "fingerId", dataIndex: "fingerId" },
      {
        title: "状态",
        key: "status",
        dataIndex: "status",
        customRender: ({ text }: { text: number }) => {
          if (text === 0) {
            return h(Tag, { color: "orange" }, () => "待分配");
          }
          if (text === 1) {
            return h(Tag, { color: "green" }, () => "已分配");
          }
          if (text === 2) {
            return h(Tag, { color: "red" }, () => "已禁用");
          }
          return "-";
        },
      },
    ];

    const buildParams = () => {
      const params: Record<string, any> = {
        pageNo: pageNo.value,
        pageSize: pageSize.value,
      };
      if (searchForm.userId) params.userId = searchForm.userId;
      if (searchForm.adsId) params.adsId = searchForm.adsId;
      if (searchForm.type !== undefined) params.type = searchForm.type;
      if (searchForm.userType !== undefined) params.userType = searchForm.userType;
      if (searchForm.timeRange && searchForm.timeRange.length === 2) {
        params.starDay = searchForm.timeRange[0];
        params.endDay = searchForm.timeRange[1];
      }
      return params;
    };

    const getData = () => {
      loading.value = true;
      recycleQueryList(buildParams())
        .then((res) => {
          loading.value = false;
          tableData.value = res?.data?.records || [];
          total.value = res?.data?.total || 0;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const search = () => {
      pageNo.value = 1;
      getData();
    };

    const reset = () => {
      searchForm.userId = "";
      searchForm.adsId = "";
      searchForm.type = undefined;
      searchForm.userType = undefined;
      searchForm.timeRange = null;
      pageNo.value = 1;
      pageSize.value = 10;
      getData();
    };

    const pageNoChange = (val: number) => {
      pageNo.value = val;
      getData();
    };

    const showSizeChange = (_current: number, size: number) => {
      pageSize.value = size;
      pageNo.value = 1;
      getData();
    };

    const exportXls = () => {
      exportLoading.value = true;
      const params = buildParams();
      delete params.pageNo;
      delete params.pageSize;
      recycleXls(params)
        .then((res: any) => {
          exportLoading.value = false;
          if (res instanceof Blob) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "回收记录.xls";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            message.success("导出成功！");
          } else {
            message.error("导出失败，请重试！");
          }
        })
        .catch(() => {
          exportLoading.value = false;
          message.error("导出失败，请重试！");
        });
    };

    onMounted(() => {
      getData();
    });

    return {
      dateFormat,
      loading,
      exportLoading,
      tableData,
      pageNo,
      pageSize,
      total,
      searchForm,
      columns,
      search,
      reset,
      pageNoChange,
      showSizeChange,
      exportXls,
    };
  },
});
